import { timeline } from "@/mocks/site";

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <span className="text-sm font-medium text-primary-600 tracking-widest uppercase">
            Timeline
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            这一类型是如何一路走来的
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            从六十年代的心理寓言，到如今的正版平台时代，韩国伦理电影在每个阶段都留下了清晰的印记。
            按时间顺序梳理，能更直观地看到题材与观众口味的变迁。
          </p>
        </div>

        <ol className="mt-10 md:mt-14 relative border-l-2 border-background-300 ml-2 md:ml-4 flex flex-col gap-8 md:gap-10">
          {timeline.map((item) => (
            <li key={item.year} className="relative pl-6 md:pl-10">
              <span className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-accent-500 border-4 border-background-100"></span>
              <div className="flex flex-col md:flex-row md:items-baseline gap-1 md:gap-4">
                <span className="font-heading text-xl md:text-2xl font-bold text-accent-700 min-w-[110px]">
                  {item.year}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {item.title}
                </h3>
              </div>
              <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
                {item.text}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}